import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import Template from "./token.template.vue";

const namespace: string = "authModule";

@Component({
  mixins: [Template]
})
export default class TokenComponent extends Vue {
  @Getter("accessToken", { namespace })
  public accessToken!: string;

  get token() {
    return this.accessToken;
  }
}
